module.exports = __webpack_public_path__ + "img/2.abec07c5.png";